import { CSSProperties } from "react";

export default function InvoiceLabelValue({
  label,
  initialValue,
  className,
  showInput,
  style,
}: {
  label: string;
  initialValue: string | null;
  className?: string;
  showInput: boolean;
  style?: CSSProperties;
}) {
  return (
    <div>
      <b>{label}: </b>
      {!showInput && (
        <p className={className} style={style}>
          {initialValue || "-"}&nbsp;
        </p>
      )}
    </div>
  );
}
